import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    contentsName: 'MainPage',
    lnbColor: ''
  },
  mutations: {
    changeContentsName (state, payload) {
      if (state.contentsName === `${payload}Page`) {
        return
      }
      state.contentsName = `${payload}Page`
      this.commit('changeLnbColor')

      TweenMax.to(window, 0, { scrollTo: 0 })
      // setTimeout(() => {
      //   new Rellax('.rellax')
      // }, 100)
    },
    changeLnbColor (state) {
      if (
        state.contentsName === 'Sub1Page' ||
        state.contentsName === 'Sub2Page' ||
        state.contentsName === 'Sub3Page' ||
        state.contentsName === 'Sub4Page' ||
        state.contentsName === 'Sub5Page'
      ) {
        state.lnbColor = 'black'
      } else {
        state.lnbColor = ''
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js